import React from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface AddToChatButtonProps {
    noun: string;
    count: number;
    singleItemName?: string;
    onClick: () => void;
    disabledReason?: string;
    detail?: string;
}

/**
 * The tooltip names the items under its title, with `detail` (a range label)
 * as the body; `disabledReason` disables the button and replaces the tooltip.
 */
export const AddToChatButton: React.FC<AddToChatButtonProps> = ({
    noun,
    count,
    singleItemName,
    onClick,
    disabledReason,
    detail,
}) => {
    const label = count === 1 ? "Add to chat" : `Add ${count} to chat`;
    const itemsName =
        singleItemName && count === 1
            ? singleItemName
            : pluralizeWithCount(noun, count);
    const tooltip =
        disabledReason === undefined
            ? { title: `Add ${itemsName} to chat`, content: detail }
            : { content: disabledReason };

    return (
        <Tooltip {...tooltip}>
            <Button
                variant="primary"
                size="md"
                onClick={onClick}
                disabled={disabledReason !== undefined}
            >
                {label}
            </Button>
        </Tooltip>
    );
};
